import "./ViewProduct.scss";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  AdminsData,
  ViewProductsColumns,
  ViewProductsFeaturesColumns,
  ViewProductsRatesColumns,
} from "../../../SourceData";
import StarIcon from "@mui/icons-material/Star";
import FeaturesImg from "./../../../assets/features-img.svg";
import AddressLocation from "./../../../assets/location-icon.png";
import DeleteUser from "./../../../assets/delete.svg";
import ViewUser from "./../../../assets/show-user.svg";
import GreenButton from "../../../components/GreenButton/GreenButton";
import Modals from "../../../components/MessageModals/MessageModals";
import BlueButton from "../../../components/BlueButton/BlueButton";
import ShopImg from "./../../../assets/shop-img.png";
import { useMediaQuery } from "@mui/material";
import SwipeableModals from "../SwipeableModals/SwipeableModals";
import api from "../../../utils/api";
import Loader from "../../../components/Loader";

const ViewProduct = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("about");
  const [currentModalView, setCurrentModalView] = useState("userRates");
  const [isOpen, setIsOpen] = useState(false);
  const [currentView, setCurrentView] = useState("");
  const [product, setProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getProduct();
    }
  }, [id]);

  const getProduct = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/productDetails/${id}`);
      setProduct(res.data.data);
    } catch (error) {
      console.error("Error fetching product:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };

  const handleModalOpen = (view) => {
    setCurrentView(view);
    setOpenModal(true);
  };

  const handleClose = () => setIsOpen(false);

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 100,
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action" style={{ justifyContent: "flex-end" }}>
            <div className="cell-btn">
              {view === "address" ? (
                <img src={AddressLocation} alt="" />
              ) : (
                <img
                  src={ViewUser}
                  alt=""
                  onClick={() => {
                    handleOpen("viewUserProductrate");
                    setSelectedProduct(params.row);
                  }}
                />
              )}
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                handleModalOpen("delete");
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  const featuresActions = [
    {
      field: "action",
      headerName: "",
      width: 240,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div
            className="cell-action"
            style={{ justifyContent: "space-between" }}
          >
            <div className="cell-btn">
              <BlueButton
                text="نطاقات الاسعار"
                size="medium"
                variant="outlined"
                onClick={() => {
                  handleOpen("viewProductranges");
                  setSelectedProduct(params.row);
                }}
              />
            </div>
            <div className="cell-btn">
              <img
                src={ViewUser}
                alt=""
                onClick={() => {
                  handleOpen("viewProductfeatures");
                  setSelectedProduct(params.row);
                }}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const renderAboutView = () => (
    <div className="about">
      <div className="factory">
        <img src={product?.vendor?.logo} alt="" />
        <p className="name">{product?.vendor?.name || "السهم العربي"}</p>
      </div>
      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={ViewProductsColumns}
        rows={[product].map((row, index) => {
          return { ...row, id: index + 1 };
        })}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        rowHeight={60}
      />
      <p className="desc-title">وصف المنتج</p>
      <p
        className="desc"
        dangerouslySetInnerHTML={{
          __html: product?.description_ar.replace(/\r\n|\n/g, "<br />"),
        }}
      />
    </div>
  );

  const renderFeaturesView = () => (
    <div className="features">
      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={ViewProductsFeaturesColumns.concat(featuresActions)}
        rows={product.variations.map((row, index) => {
          return { ...row, index: index + 1 };
        })}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        rowHeight={60}
      />
    </div>
  );

  const renderPhotosView = () => (
    <div className="photos">
      {product?.gallery?.map((photo, index) => (
        <img key={index} src={photo.image_path || FeaturesImg} alt="" />
      )) || (
        <>
          <img src={FeaturesImg} alt="" />
          <img src={FeaturesImg} alt="" />
          <video src="" controls />
          <img src={FeaturesImg} alt="" />
          <img src={FeaturesImg} alt="" />
        </>
      )}
    </div>
  );

  const renderRatesView = () => (
    <div className="container">
      <DataGrid
        sx={{ backgroundColor: "white", width: "100%" }}
        autoHeight={true}
        columns={ViewProductsRatesColumns.concat(actionColumn)}
        rows={(product?.comments || AdminsData).map((row, index) => {
          return { ...row, index: index + 1 };
        })}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        hideFooter
        rowHeight={60}
      />
    </div>
  );

  const views = {
    about: renderAboutView,
    features: renderFeaturesView,
    photos: renderPhotosView,
    rates: renderRatesView,
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="view-product">
      <div className="product-header">
        <div className="product-info">
          <div className="info-container">
            <p className="title">تفاصيل المنتج</p>
            <div className="info">
              <img src={product?.image || ShopImg} alt="" />
              <div className="wrapper">
                <p className="name">{product?.name_ar || "لا يوجد"}</p>
                <p className="price">{product?.price || "لا يوجد"} جنية</p>
                <span className="phone">
                  <StarIcon style={{ color: "#F9A130" }} />
                  <span>{product?.rating || 0}</span>
                  <span>({product?.comments?.length || 0})</span>
                </span>
              </div>
            </div>
          </div>

          <div className="widgets">
            <Link className="widget">
              <div className="widget-text-container">
                <p className="number">{product?.buy_count || 0}</p>
              </div>
              <span className="widget-title">عدد مرات الشراء</span>
            </Link>

            <Link className="widget">
              <div className="widget-text-container">
                <p className="number">{product?.favorites_count || 0}</p>
              </div>

              <span className="widget-title">عدد مرات الاضافة للمفضلة</span>
            </Link>

            {/* <Link className="widget">
              <div className="widget-text-container">
                <p className="number">{product?.share_count || 0}</p>
              </div>

              <span className="widget-title">عدد مرات المشاركة</span>
            </Link> */}

            <Link className="widget">
              <div className="widget-text-container">
                <p className="number">{product?.stock || 0}</p>
                <span>قطعة</span>
              </div>

              <span className="widget-title">الكمية المتاحة</span>
            </Link>
          </div>
        </div>

        <div className="btns-container">
          <GreenButton
            text="عن المنتج"
            size={isMobile ? "full" : "small"}
            variant={view === "about" ? "fill" : "outlined"}
            onClick={() => setView("about")}
          />

          <GreenButton
            text="السمات"
            size={isMobile ? "full" : "small"}
            variant={view === "features" ? "fill" : "outlined"}
            onClick={() => setView("features")}
          />

          <GreenButton
            text="صور المنتج"
            size={isMobile ? "full" : "medium"}
            variant={view === "photos" ? "fill" : "outlined"}
            onClick={() => setView("photos")}
          />

          <GreenButton
            text="التقييمات"
            size={isMobile ? "full" : "small"}
            variant={view === "rates" ? "fill" : "outlined"}
            onClick={() => setView("rates")}
          />
        </div>
      </div>

      {views[view]()}

      <Modals
        open={openModal}
        currentView={currentView}
        onClose={() => {
          setOpenModal(false);
        }}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        item={selectedProduct}
      />
    </div>
  );
};

export default ViewProduct;
